<div class="re-container-headline bdo-space--bottom">
  <h3>
    {{ 'confirmation.order.title' | translate }}
  </h3>
</div>
<div class="re-container-with-margin">

  @if (registrationError) {
    <bdo-info-box [type]="'warning'">
      {{ 'confirmation.error.registration' | translate }}
    </bdo-info-box>
  }
  <div class="re-copytext-with-margin">
    {{ 'confirmation.order.description' | translate }}
  </div>
  <h2 class="re-mb-15 lg:re-mb-30">{{ 'confirmation.title' | translate }}</h2>
  <ul class="bdo-list__bullet_bigger re-text-sm re-leading-m re-mb-45 lg:re-text-base lg:re-leading-2xl lg:re-mb-60">
    <li class="re-mb-5"
      [innerHTML]="'confirmation.order.acknowledgment' | translate: { emailAddress: personalData?.email }">
    </li>
    @if (situationData?.previousSupplier) {
      <li class="re-mb-5"
        [innerHTML]="'confirmation.order.cancelPreviousSupplier' | translate: { previousSupplier: situationData?.previousSupplier }">
      </li>
    }
    <li data-qa="documents"
      [innerHTML]="'confirmation.order.documents' | translate"
      class="re-mb-5">
    </li>
    @if (situationData?.startDate) {
      <li class="re-mb-5"
        [innerHTML]="'confirmation.order.supplyBegins' | translate: { startDate: situationData?.startDate | date }">
      </li>
    }
    @if (personalData?.registrationData?.username) {
      <li
        [innerHTML]="'confirmation.order.registrationLink' | translate">
      </li>
    }
    @if (wishvoucherAmount) {
      <li
        class="re-mt-5"
        [innerHTML]="'confirmation.order.wishvoucher' | translate: { amount: wishvoucherAmount | currency: 'EUR' }">
      </li>
    }
    @if (tariffService.isEffzeh([tariffData.productId])) {
      <li class="re-mt-5 md:re-mt-10">{{ 'confirmation.order.effzehVoucher' | translate}}</li>
      <li class="re-mt-5 md:re-mt-10">{{ 'confirmation.order.effzehPayout' | translate}}</li>
      <li class="re-mt-5 md:re-mt-10">{{ 'confirmation.order.effzehCompetition' | translate}}</li>
    }
    @if (tariffService.isHaieTariff([tariffData?.productId])) {
      <li class="re-mt-5 md:re-mt-10">{{ 'confirmation.order.haieVoucher' | translate}}</li>
      <li class="re-mt-5 md:re-mt-10">{{ 'confirmation.order.haiePayout' | translate}}</li>
      <li class="re-mt-5 md:re-mt-10">{{ 'confirmation.order.haieCompetition' | translate}}</li>
    }
    @if (isChargeFlex) {
      <li class="re-mt-5 md:re-mt-10"
      [innerHTML]="
      'confirmation.order.chargeFlex' | translate"
      ></li>
    }
  </ul>
</div>

@if (trustpilotUniqueUrl) {
  <bdo-trustpilot
    [trustpilotUniqueUrl]="trustpilotUniqueUrl">
  </bdo-trustpilot>
}

@if (!tariffService.isEffzeh([tariffData?.productId])
     && !tariffService.isHaieTariff([tariffData?.productId])) {
  <bdo-netcologne-teaser
    [postCode]="personalData?.addressData?.postCode"
    [trackingLocation]="TRACKING.LOCATION.DELIVERY_CONFIRMATION"
  ></bdo-netcologne-teaser>
}

<bdo-effzeh-strom-teaser [productIds]="[tariffData?.productId]"></bdo-effzeh-strom-teaser>

<bdo-haie-strom-teaser [productIds]="[tariffData?.productId]"></bdo-haie-strom-teaser>
